<template>
  <div class="layer-image-tiles" @wheel="horizontalScroll">
    <a
      v-for="sl in filteredLayers"
      :key="sl.id"
      :href="sl.view"
      target="_self"
      v-show="sl.active"
    >
      <div
        class="layer-image-tile"
        v-lazy:background-image="getThumbnailUrl(sl)"
      >
        <div class="layer-image-tile__title">
          {{ sl.name }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { LAYERS } from '@/constants/gmaps.js';

export default {
  props: {
    orderedLayers: {
      type: Array,
      required: true
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    filteredLayers: function () {
      let filtered1 = this.orderedLayers.filter((l) => l.view);
      return filtered1.filter((l) => l.thumbnailUrl);
    }
  },
  methods: {
    getThumbnailUrl(layer) {
      return LAYERS.baseUrl + layer.phaseId + '/' + layer.thumbnailUrl;
    },
    horizontalScroll(event) {
      this.$el.scrollLeft -= event.deltaY;
      event.preventDefault();
    }
  }
};
</script>

<style scoped>
.layer-image-tiles {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow-x: auto;
  padding: 0.5rem 0 1rem 0;
  box-sizing: border-box;
}
.layer-image-tile {
  display: flex;
  flex-grow: 1;
  min-width: 15rem;
  height: 10rem;
  max-height: 100%;
  align-content: flex-end;
  margin: 0 0.5rem;
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.18);
  border-radius: 0.2rem;
  background-size: cover;
  background-position: center;
}
.layer-image-tile__title {
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0.9rem;
  border-radius: 0.2rem;

  background: rgba(26, 25, 25, 0.18);
  background: linear-gradient(
    0deg,
    rgba(256, 255, 255, 1) 0%,
    rgba(256, 255, 255, 0) 100%
  );

  color: #1a1919;
  font-weight: bold;
  transition: all 0.2s;
}
.layer-image-tile:hover .layer-image-tile__title {
  padding-bottom: 1.15rem;
}
.layer-image-tiles a::after {
  display: none;
}
.layer-image-tiles a {
  background: none;
}
</style>
